export const getPercentage = (num, dem) => {
  if (num <= 0) return 0;
  return ((num / (dem || 1)) * 100).toFixed(1);
};

export const getDynamicPercentage = (datum, dynamic_total) => {
  const result = {};
  for (let i = 0; i < 15; i++) {
    result[`s${i + 1}_per`] = getPercentage(
      datum[`s${i + 1}_total_count`],
      dynamic_total[i]
    );
  }
  return result;
};
